module.exports = __webpack_public_path__ + "img/FishSoup.d36b4724.jpeg";